import { timeParse } from 'd3'
const capitalStructureChartData = [
  {
    "dateString": "2010-12-31",
    "otherLongTerm": "65878.17783",
    "otherShortTerm": "65761.44871",
    "equity": "58267.92218",
    "shortTermDebt": "24356.40795",
    "longTermDebt": "21349.94882",
    "chart_name": "Capital Structure - Composition over Time",
    "chart_number": "1"
  },
  {
    "dateString": "2011-06-30",
    "otherLongTerm": "69041.37384",
    "otherShortTerm": "68914.56281",
    "equity": "62170.14881",
    "shortTermDebt": "23969.1135",
    "longTermDebt": "18706.16391",
    "chart_name": "Capital Structure - Composition over Time",
    "chart_number": "1"
  },
  {
    "dateString": "2011-12-31",
    "otherLongTerm": "78657.67832",
    "otherShortTerm": "78497.1427",
    "equity": "69316.80403",
    "shortTermDebt": "26478.00922",
    "longTermDebt": "25853.79204",
    "chart_name": "Capital Structure - Composition over Time",
    "chart_number": "1"
  },
  {
    "dateString": "2012-06-30",
    "otherLongTerm": "73221.73191",
    "otherShortTerm": "73001.1271",
    "equity": "62378.92773",
    "shortTermDebt": "25360.06698",
    "longTermDebt": "24988.94049",
    "chart_name": "Capital Structure - Composition over Time",
    "chart_number": "1"
  },
  {
    "dateString": "2012-12-31",
    "otherLongTerm": "80511.79161",
    "otherShortTerm": "80236.3109",
    "equity": "68569.5222",
    "shortTermDebt": "25272.2975",
    "longTermDebt": "24893.15692",
    "chart_name": "Capital Structure - Composition over Time",
    "chart_number": "1"
  },
  {
    "dateString": "2013-06-30",
    "otherLongTerm": "78151.7571",
    "otherShortTerm": "77765.22715",
    "equity": "65140.00683",
    "shortTermDebt": "25187.48234",
    "longTermDebt": "24966.02303",
    "chart_name": "Capital Structure - Composition over Time",
    "chart_number": "1"
  },
  {
    "dateString": "2013-12-31",
    "otherLongTerm": "88900.62062",
    "otherShortTerm": "88438.35756",
    "equity": "75052.97364",
    "shortTermDebt": "25042.20108",
    "longTermDebt": "23438.83414",
    "chart_name": "Capital Structure - Composition over Time",
    "chart_number": "1"
  },
  {
    "dateString": "2014-06-30",
    "otherLongTerm": "77805.47689",
    "otherShortTerm": "77267.00582",
    "equity": "65375.60506",
    "shortTermDebt": "24746.36378",
    "longTermDebt": "24699.24165",
    "chart_name": "Capital Structure - Composition over Time",
    "chart_number": "1"
  },
  {
    "dateString": "2014-12-31",
    "otherLongTerm": "87998.86607",
    "otherShortTerm": "87191.81883",
    "equity": "74675.58399",
    "shortTermDebt": "24816.9624",
    "longTermDebt": "24771.85244",
    "chart_name": "Capital Structure - Composition over Time",
    "chart_number": "1"
  },
  {
    "dateString": "2015-06-30",
    "otherLongTerm": "85491.87308",
    "otherShortTerm": "84661.28813",
    "equity": "65749.32228",
    "shortTermDebt": "26162.02657",
    "longTermDebt": "26117.30211",
    "chart_name": "Capital Structure - Composition over Time",
    "chart_number": "1"
  },
  {
    "dateString": "2015-12-31",
    "otherLongTerm": "83482.221",
    "otherShortTerm": "82606.26805",
    "equity": "71486.63184",
    "shortTermDebt": "26236.56729",
    "longTermDebt": "26189.46188",
    "chart_name": "Capital Structure - Composition over Time",
    "chart_number": "1"
  },
  {
    "dateString": "2016-06-30",
    "otherLongTerm": "80584.54193",
    "otherShortTerm": "79331.21408",
    "equity": "67602.94697",
    "shortTermDebt": "34061.54325",
    "longTermDebt": "33559.21598",
    "chart_name": "Capital Structure - Composition over Time",
    "chart_number": "1"
  },
  {
    "dateString": "2016-12-31",
    "otherLongTerm": "86703.47645",
    "otherShortTerm": "85354.42835",
    "equity": "72732.30015",
    "shortTermDebt": "33912.2781",
    "longTermDebt": "33710.6962",
    "chart_name": "Capital Structure - Composition over Time",
    "chart_number": "1"
  },
  {
    "dateString": "2017-06-30",
    "otherLongTerm": "80117.59635",
    "otherShortTerm": "78642.1773",
    "equity": "66440.69595",
    "shortTermDebt": "38282.8308",
    "longTermDebt": "37978.37925",
    "chart_name": "Capital Structure - Composition over Time",
    "chart_number": "1"
  },
  {
    "dateString": "2017-12-31",
    "otherLongTerm": "83230.7931",
    "otherShortTerm": "82026.9289",
    "equity": "69964.835",
    "shortTermDebt": "34489.9276",
    "longTermDebt": "34067.7934",
    "chart_name": "Capital Structure - Composition over Time",
    "chart_number": "1"
  },
  {
    "dateString": "2018-06-30",
    "otherLongTerm": "81161.18025",
    "otherShortTerm": "79898.0628",
    "equity": "65635.0347",
    "shortTermDebt": "38168.11425",
    "longTermDebt": "37516.9419",
    "chart_name": "Capital Structure - Composition over Time",
    "chart_number": "1"
  },
  {
    "dateString": "2018-12-31",
    "otherLongTerm": "94406.3023",
    "otherShortTerm": "93200.5824",
    "equity": "78066.44885",
    "shortTermDebt": "43546.8447",
    "longTermDebt": "43468.5512",
    "chart_name": "Capital Structure - Composition over Time",
    "chart_number": "1"
  },
  {
    "dateString": "2019-06-30",
    "otherLongTerm": "86656.25",
    "otherShortTerm": "85492.1875",
    "equity": "70906.25",
    "shortTermDebt": "43906.25",
    "longTermDebt": "43765.625",
    "chart_name": "Capital Structure - Composition over Time",
    "chart_number": "1"
  },
  {
    "dateString": "2019-12-31",
    "otherLongTerm": "94280.78",
    "otherShortTerm": "92979.5494",
    "equity": "78338.7572",
    "shortTermDebt": "43696.4144",
    "longTermDebt": "43548.3702",
    "chart_name": "Capital Structure - Composition over Time",
    "chart_number": "1"
  },
  {
    "dateString": "2020-06-30",
    "otherLongTerm": "87851.35075",
    "otherShortTerm": "86603.5283",
    "equity": "75969.9109",
    "shortTermDebt": "54818.93285",
    "longTermDebt": "54671.6743",
    "chart_name": "Capital Structure - Composition over Time",
    "chart_number": "1"
  }
]

const parsedateString = timeParse('%Y-%m-%d')
export default capitalStructureChartData.map(d => {
  d['date'] = parsedateString(d['dateString'])
  return d
})
